import { allPages } from "@majitap/ui";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { api, ok } from "./api";

/** The company's products with their items, every page of them (any staff member may read them). */
export const productsQuery = queryOptions({
  queryKey: ["catalog", "products"],
  staleTime: 5 * 60_000,
  queryFn: () =>
    allPages((cursor) => ok(api.GET("/v1/admin/catalog/products", { params: { query: { cursor, limit: 100 } } }))),
});

/** "Water · 10,000 L load" for each product item id, and the items that can be ordered. */
export function useProductItems() {
  const products = useQuery(productsQuery);
  const items = (products.data ?? []).flatMap((p) =>
    p.items.map((item) => ({ ...item, label: `${p.name} · ${item.name}`, orderable: p.is_active && item.is_active })),
  );
  return {
    status: products.status,
    items,
    labelOf: (id: string | null) => items.find((i) => i.id === id)?.label ?? "Item",
  };
}

/** The company's product categories, by name: for a product, and for pricing a whole category. */
export const categoriesQuery = queryOptions({
  queryKey: ["catalog", "categories"],
  staleTime: 5 * 60_000,
  queryFn: async () => (await ok(api.GET("/v1/admin/catalog/categories"))).data,
});

export const categoryActions = {
  create: (name: string) => ok(api.POST("/v1/admin/catalog/categories", { body: { name } })),
  rename: (id: string, name: string) =>
    ok(api.PATCH("/v1/admin/catalog/categories/{id}", { params: { path: { id } }, body: { name } })),
};
